import { render, staticRenderFns } from "./approve-reject-card.vue?vue&type=template&id=3da54c08"
import script from "./approve-reject-card.vue?vue&type=script&lang=js"
export * from "./approve-reject-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports